export const Capacitor = {
  isNativePlatform() { return false; },
  getPlatform() { return "web"; },
};
export default Capacitor;
